import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
  UserSubOrderV2EnrichedStatusEnum,
} from '@redteclab/api/clients/bully'

import { userSubOrderAccessorIsCancellationRequested } from './userSubOrderAccessor'

type SubOrderTrackingSelfServiceAvailability = 'disabled' | 'enabled' | 'hidden'

const TRACKING_AVAILABILITY_DAYS_AFTER_SHIPMENT = 21

const subOrderTrackingIsExpired = (shippedDate?: string): boolean => {
  if (!shippedDate) {
    return false
  }

  const trackingAvailableUntil = new Date(shippedDate)

  if (Number.isNaN(trackingAvailableUntil.getTime())) {
    return false
  }

  trackingAvailableUntil.setDate(
    trackingAvailableUntil.getDate() +
      TRACKING_AVAILABILITY_DAYS_AFTER_SHIPMENT,
  )

  return Date.now() > trackingAvailableUntil.getTime()
}

export const subOrderStatusAccessorGetTrackingSelfServiceAvailability = (
  subOrder: UserOrderResponseWithFlagsSubOrdersInner | UserSubOrderV2,
): SubOrderTrackingSelfServiceAvailability => {
  if (userSubOrderAccessorIsCancellationRequested(subOrder)) {
    return 'hidden'
  }

  switch (subOrder.enrichedStatus) {
    case UserSubOrderV2EnrichedStatusEnum.Canceled:
    case UserSubOrderV2EnrichedStatusEnum.CancelRequested:
    case UserSubOrderV2EnrichedStatusEnum.Closed:
    case UserSubOrderV2EnrichedStatusEnum.Completed:
    case UserSubOrderV2EnrichedStatusEnum.New:
    case UserSubOrderV2EnrichedStatusEnum.WaitingForPrepayment: {
      return 'hidden'
    }
    case UserSubOrderV2EnrichedStatusEnum.Dispatched:
    case UserSubOrderV2EnrichedStatusEnum.ReadyForPickup: {
      return subOrderTrackingIsExpired(subOrder.shippedDate)
        ? 'hidden'
        : 'enabled'
    }
    case UserSubOrderV2EnrichedStatusEnum.Processing: {
      return 'disabled'
    }
    default: {
      return 'hidden'
    }
  }
}
